import angular from 'angular';
import maintenaceAdminFormComponent from './maintenance-admin-form.component';

export default angular.module('components.app.product.maintenanceAdminForm', [])
  .component('maintenanceAdminForm', maintenaceAdminFormComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/maintenance-admin-form/maintenance-admin-form.module.js